import { formOptions } from '@tanstack/react-form';

export const patientAssignmentFormOptions = formOptions({
	defaultValues: {
		study_identifier: '',
		patient_status: '',
	},
});
